import styled from "styled-components";

const Card = styled.div`
  background: var(--color-grey-200);
  width: 30rem;
  border-radius: 2rem;
  height: 37rem;
  cursor: pointer;
  box-shadow: var(--box-shadow);
  transition: all 0.2s ease-in-out;

  &:hover {
    transform: scale(1.05);
  }

  img {
    height: 170px;
    width: 100%;
    object-fit: cover;
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
  }

  h2 {
    margin: 2rem;
    font-size: 2rem;
    color: var(--color-grey-900);
  }

  p {
    margin: 0 2rem;
    margin-bottom: 1rem;
    font-size: 1.2rem;
    color: var(--color-grey-700);
    text-decoration: none;
    display: flex;
    justify-content: space-between;

    span {
      font-weight: bold;
      color: var(--color-grey-900);
    }
  }
`;

function CountryCard({ flag, name, population, region, capital, subregion }) {
  return (
    <Card>
      <img src={flag} alt="Country Flag" />
      <h2>{name}</h2>
      <p>
        <span>Region:</span> {region}
      </p>
      <p>
        <span>Subregion:</span> {subregion}
      </p>
      <p>
        <span>Population:</span> {population}
      </p>
      <p>
        <span>Capital:</span> {capital}
      </p>
    </Card>
  );
}

export default CountryCard;
